import clsx from "clsx";
import type { ReactNode } from "react";

interface GuideParagraphProps {
  children: ReactNode;
}

export function GuideParagraph({ children }: GuideParagraphProps) {
  return <p className={clsx("font-normal", "text-base", "text-gray-700", "leading-relaxed")}>{children}</p>;
}
